// extracted by mini-css-extract-plugin
export default {"container":"MainTemplate_container__-1UE5","appear":"MainTemplate_appear__jf5fG"};